export default __webpack_public_path__ + "i18n/translations/translation-mr.1c00c0b7.json";